import { useCallback } from 'react';
import { useFormatBracketsOptions } from 'utils/formatBrackets/formatBracketsOptions';
import { findFormatterByKey, getFeatureDisplayName, getNameOverrideOrDisplayName } from '.';

export interface FeatureParsingProps {
  addStain: boolean;
  studyId: string;
}

export const useGetFeatureDisplayNameWithContext = ({ addStain, studyId }: FeatureParsingProps) => {
  const formatBracketsOptions = useFormatBracketsOptions({ addStain, studyId });

  const isLoadingFormatterData = formatBracketsOptions.isLoading;

  const getFeatureDisplayNameWithContext = useCallback(
    (featureKey: string, orchestrationId: string) => {
      return getFeatureDisplayName(featureKey, { ...formatBracketsOptions, orchestrationId });
    },
    [formatBracketsOptions]
  );

  return { getFeatureDisplayNameWithContext, isLoadingFormatterData };
};

export const useFindFormatterByKeyWithContext = ({ addStain, studyId }: FeatureParsingProps) => {
  const formatBracketsOptions = useFormatBracketsOptions({ addStain, studyId });

  const isLoadingFormatterData = formatBracketsOptions.isLoading;

  const findFormatterByKeyWithContext = useCallback(
    (featureKey: string, orchestrationId: string) => {
      const context = { ...formatBracketsOptions, orchestrationId };
      return findFormatterByKey(featureKey, {
        featureDisplayName: getFeatureDisplayName(featureKey, context),
        context,
      });
    },
    [formatBracketsOptions]
  );

  return { findFormatterByKeyWithContext, isLoadingFormatterData };
};

export const useGetNameOverrideOrDisplayNameWithContext = ({ addStain, studyId }: FeatureParsingProps) => {
  const formatBracketsOptions = useFormatBracketsOptions({ addStain, studyId });

  const isLoadingFormatterData = formatBracketsOptions.isLoading;

  const getNameOverrideOrDisplayNameWithContext = useCallback(
    (featureKey: string, orchestrationId: string) => {
      return getNameOverrideOrDisplayName(featureKey, { ...formatBracketsOptions, orchestrationId });
    },
    [formatBracketsOptions]
  );
  return { getNameOverrideOrDisplayNameWithContext, isLoadingFormatterData };
};
